import React, {useCallback, useState} from 'react';

import {FileWithPath, useDropzone} from 'react-dropzone';

import axios from 'axios';
import {Invoice} from "./utils";

const ENV_IS_PRODUCTION = process.env.NODE_ENV === 'production';

var API_KEY: string | undefined;
var baseURL: string | undefined;
if(ENV_IS_PRODUCTION){
    API_KEY = process.env.REACT_APP_API_KEY_PRODUCTION;
    baseURL = process.env.REACT_APP_BASE_URL_PRODUCTION;
}
else{
    API_KEY = process.env.REACT_APP_API_KEY_STAGING;
    baseURL = process.env.REACT_APP_BASE_URL_STAGING;
}

console.log(`ENV_IS_PRODUCTION: ${ENV_IS_PRODUCTION}`);

interface Props {
    onContentProcessed: (result: Invoice) => void;
}

const Dropzone: React.FC<Props> = ({onContentProcessed}) => {

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    const [uploadProgress, setUploadProgress] = useState(0);
    const [processingProgress, setProcessingProgress] = useState(0);

    const onDrop = useCallback(async (acceptedFiles:FileWithPath []) => {

        const sendToServer = async (file: File):Promise<Invoice|null> => {

            setUploadProgress(0);

            const intervalId = simulateProcessing();


            let parseResult: Invoice|null = null;

            if (!file) {
                console.log('no file to upload');
                return parseResult;
            }

            const formData = new FormData();
            formData.append('file', file);
            const config = {
                headers: {
                    'content-type': 'multipart/form-data',
                    'x-api-key': API_KEY
                    // 'Content-Type': file.type
                },
                onUploadProgress: (progressEvent:any) => {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setUploadProgress(percentCompleted);
                }
            };

            try {

                const response = await axios.post(baseURL + "/api/upload/bond", formData, config);

                clearInterval(intervalId);

                const data = response.data.data;

                parseResult = {
                    invoiceNumber: data.invoiceNumber,
                    grossAmount: data.grossAmount,
                    vendorName: data.vendorName,
                    orderNumber: data.orderNumber,
                    productDescription: data.productDescription,
                    customerNumber: data.customerNumber,
                    currency: data.currency,
                    totalVat: data.totalVat,
                }

                console.log(data);

            }
            catch (error) {
                clearInterval(intervalId);
                console.error("Error occurred while uploading: ", error);
            }

            return parseResult;

        };

        setLoading(true);
        setError(null);
        const file = acceptedFiles[0];
        try {
            const result = await sendToServer(file);
            onContentProcessed(result!);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            setError('Uoh, something went wrong');
            console.error("Error processing image:", error);
        }
    }, [onContentProcessed]);

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: {
            images: ['image/jpeg', 'image/png'],
            documents: ['application/pdf']
        },
        disabled: false
    }) as {
        getRootProps: () => {};
        getInputProps: () => {};
    }

    let displayMessage = "Drag & drop an impact report here, or click to select one";

    if (loading) {
        if(uploadProgress < 100) {
            displayMessage = "Uploading...";
        }
        else {
            displayMessage = "Processing...";
        }
    }
    if (error) {
        displayMessage = error;
    }

    const simulateProcessing = () => {
        let progress = 0;
        const interval = setInterval(() => {
            progress += 5;  // Increment by 5% every tick
            setProcessingProgress(progress);

            if (progress >= 100) {
                clearInterval(interval);
            }
        }, 500);  // Update every half-second

        return interval;  // Return the interval ID so you can clear it later if needed
    };


    return (
      <div>
          <div {...getRootProps()} className="dropzone">
              <input {...getInputProps()} />
              <p>{displayMessage}</p>
          </div>
          {loading && uploadProgress < 100 ? (
            <div className="progress-container">
                <div className="progress-bar" style={{width: `${uploadProgress}%`}}></div>
            </div>
          ) : (
            <p></p>
          )}
          {loading && uploadProgress >= 100 ? (
            <div className="progress-container">
                <div className="progress-bar" style={{width: `${processingProgress}%`}}></div>
            </div>
          ) : (
            <p></p>
          )}
      </div>
    );
};






export default Dropzone;
